<div class="upload-form" *transloco="let t">
  <tabset #staticTabs>
    @if (gallery?.length) {
      <tab heading="{{t('content_management.gallery')}}"
        (selectTab)="changeSource('gallery',$event)">
        @if (!gallery?.length) {
          <p>Empty</p>
        }
        <div>
          @if (gallery?.length) {
            <div class="my-3 gallery">
              @if (isAdmin) {
                <div class="row my-4">
                  <div class="col-lg-4">
                    <div class="input-group mb-3">
                      <input type="text" class="form-control" [(ngModel)]="searchTerm" (keyup)="filterGallery()"
                        [placeholder]="t('common.start_typing')" aria-label="Search term" aria-describedby="searchbox">
                      <span class="input-group-text" id="searchbox"><i class="fa fa-search"></i></span>
                      <!-- <input type="text" class="form-control" placeholder="Search..." aria-label="Recipient's username"
                      aria-describedby="search-icon">
                      <div class="input-group-append">
                        <button type="button" class="btn btn-sm btn-primary" id="search-icon">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div class="w-100 h-100 bg-success text-white d-flex align-items-center justify-content-center">
                      Pagination placeholder
                    </div>
                  </div>
                </div>
              }
              <!-- Media object -->
              <div class="row">
                @for (item of filteredGallery; track item) {
                  <div class="gallery-item my-2 col-lg-3 col-md-6"
                    (click)="onSelectGalleryItem(item.id)">
                    <div class="card bg-dark text-white"
                      [ngClass]="{'selected': item.id === selectedGalleryItemId}">
                <img class="card-img" [src]="item | imageUrl:imageTransformations" [alt]="item.alt_text">
                      <div class="card-img-overlay">
                        @if (item.id !== selectedGalleryItemId) {
                          <div class="select">
                            <i class="fa-solid fa-circle-check mr-1"></i>{{t('common.select')}}
                          </div>
                        }
                        @if (item.id === selectedGalleryItemId) {
                          <div class="selected text-success">
                            <i class="fa-solid fa-circle-check text-success mr-1"></i>{{t('common.selected')}}
                          </div>
                        }
                        <div class="globe">
                          <!-- <multisite-loader-globe-animation-detail *ngIf="item.id === selectedGalleryItemId && uploadProgress"
                          [width]="60" [height]="60" class="d-inline-block align-bottom">
                        </multisite-loader-globe-animation-detail> -->
                      </div>
                    </div>
                  </div>
                  <h5 class="fw-bold mt-3">
                    {{ item.caption }}
                    <small class="text-muted">{{ '' }}</small>
                  </h5>
                  <p>
                    {{ item.credits }}
                  </p>
                  @if (item.id === selectedGalleryItemId) {
                    <div class="mt-2">
                      @if (successMessage) {
                        <alert class="mt-3 w-100" [type]="'success'" [dismissOnTimeout]="5000">
                          <strong class="mr-1">
                            {{ t('common.success') }}
                          </strong>
                          {{ t(successMessage) }}
                        </alert>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Media object -->
          </div>
        }
      </div>
    </tab>
  }
  <tab heading="{{t('content_management.file_on_device')}}" (selectTab)="changeSource('local',$event)">
    <form class="position-relative" [formGroup]="fileUploadForm" (submit)="onUploadSubmit()" role="form">
      <div class="row mt-4">
        <div class="col-lg-6">
          @if (!askForLicenceAndCredit && fileDescriptionTranslationKey) {
            <label for="formFile">{{
              t(fileDescriptionTranslationKey)}}<span class="required-sign">*</span></label>
            }
            <div [ngClass]="{'input-group': !askForLicenceAndCredit}">
              <div class="input-group">
                @if (askForLicenceAndCredit) {
                  <label for="formFile" class="form-label w-100">{{
                    t(fileDescriptionTranslationKey)
                    }}<span class="required-sign">*</span>
                  </label>
                }
                <input class="form-control" type="file" id="formFile" [accept]="requiredFileType"
                  formControlName="fileData" (change)="onFileSelected($event)" [attr.disabled]="disabled ? true : null"
                  #fileUpload />
                <button type="submit" class="btn btn-sm btn-primary primary-dark"
                  [disabled]="fileUploadForm.invalid || uploadProgress || disabled">
                  {{ t(uploadButtonTranslationKey) }}
                </button>
              </div>
            </div>


          </div>
          <div class="col-lg-6">
            @if (askForLicenceAndCredit) {
              <div class="input-self mb-3">
                <!-- <div class="input-self mb-3"> -->
                <label for="licence" class="form-label">{{ t('common.licence')
                  }}<span class="required-sign">*</span>
                </label>
              <div class="input-group" [ngClass]="{
                'ng-invalid':
                  fileUploadForm.get('licence').invalid &&
                  fileUploadForm.get('licence').touched,
                'ng-valid':
                  fileUploadForm.get('licence').valid &&
                  fileUploadForm.get('licence').touched &&
                  fileUploadForm.get('licence').dirty
              }">
                  <span class="input-group-text text-primary-light">
                    <i class="fa fa-circle-check" aria-hidden="true"></i>
                  </span>
                  <input class="form-control" type="text" formControlName="licence" id="licence"
                    [attr.disabled]="disabled ? true : null" placeholder="Creative Commons 2.0 Share Alike" />
                  @if (
                    fileUploadForm.get('licence').errors?.required &&
                    fileUploadForm.get('licence').touched
                    ) {
                    <div class="invalid-feedback">
                      {{ t('common.required') }}
                    </div>
                  }
                  @if (
                    fileUploadForm.get('licence').errors?.licence &&
                    fileUploadForm.get('licence').touched
                    ) {
                    <div class="invalid-feedback">
                      <!--  -->
                    </div>
                  }
                </div>
                <div class="form-text">
                  {{ t('content_management.image_licence') }}
                </div>
              </div>
            }

            @if (askForLicenceAndCredit) {
              <div class="input-self mb-3">
                <label for="licence_url" class="form-label">{{ t('common.licence_url') }}
                </label>
              <div class="input-group" [ngClass]="{
                'ng-invalid':
                  fileUploadForm.get('licence_url').invalid &&
                  fileUploadForm.get('licence_url').touched,
                'ng-valid':
                  fileUploadForm.get('licence_url').valid &&
                  fileUploadForm.get('licence_url').touched &&
                  fileUploadForm.get('licence_url').dirty
              }">
                  <span class="input-group-text text-primary-light">
                    <i class="fa fa-link" aria-hidden="true"></i>
                  </span>
                  <input class="form-control" type="text" formControlName="licence_url" id="licence_url"
                    [attr.disabled]="disabled ? true : null"
                    placeholder="https://creativecommons.org/licenses/by-sa/4.0/" />
                  @if (
                    fileUploadForm.get('licence_url').errors?.required &&
                    fileUploadForm.get('licence_url').touched
                    ) {
                    <div class="invalid-feedback">
                      {{ t('common.required') }}
                    </div>
                  }
                  @if (
                    fileUploadForm.get('licence_url').errors?.minlength &&
                    fileUploadForm.get('licence_url').touched
                    ) {
                    <div class="invalid-feedback">
                      {{ t('common.too_short') }}
                    </div>
                  }
                </div>
                <div class="form-text">
                  {{ t('content_management.image_licence_address') }}
                </div>
              </div>
            }

            @if (askForLicenceAndCredit) {
              <div class="input-self mb-3">
                <label for="credit" class="form-label">{{ t('common.credit')
                  }}<span class="required-sign">*</span>
                </label>
              <div class="input-group" [ngClass]="{
                'ng-invalid':
                  fileUploadForm.get('credit').invalid &&
                  fileUploadForm.get('credit').touched,
                'ng-valid':
                  fileUploadForm.get('credit').valid &&
                  fileUploadForm.get('credit').touched &&
                  fileUploadForm.get('credit').dirty
              }">
                  <span class="input-group-text text-primary-light">
                    <i class="fa fa-id-card" aria-hidden="true"></i>
                  </span>
                  <input class="form-control" type="text" formControlName="credit" id="credit"
                    placeholder="UNICEF/UN0792788/Tibaweswa" [attr.disabled]="disabled ? true : null" />
                  @if (
                    fileUploadForm.get('credit').errors?.required &&
                    fileUploadForm.get('credit').touched
                    ) {
                    <div class="invalid-feedback">
                      {{ t('common.required') }}
                    </div>
                  }
                  @if (
                    fileUploadForm.get('credit').errors?.minlength &&
                    fileUploadForm.get('credit').touched
                    ) {
                    <div class="invalid-feedback">
                      {{ t('common.too_short') }}
                    </div>
                  }
                </div>
                <div class="form-text">
                  {{ t('content_management.credit') }}
                </div>
              </div>
            }
          </div>
          @if (!emitOnChange) {
            <div class="d-flex flex-column w-100 my-2 justify-content-end align-items-end my-3">
              @if (errorMessage) {
                <alert class="mt-1 w-100" [type]="'warning'">
                  <strong class="mr-1">
                    {{ t('common.problem') }}
                  </strong>
                  {{ t(errorMessage) }}
                </alert>
              }
              @if (successMessage) {
                <alert class="mt-1 w-100" [type]="'success'" [dismissOnTimeout]="5000">
                  <strong class="mr-1">
                    {{ t('common.success') }}
                  </strong>
                  {{ t(successMessage) }}
                </alert>
              }
              <!-- <p>Errors: {{fileUploadForm.get('remoteFileUrl').errors | json}}</p> -->
              @if (askForLicenceAndCredit) {
                <button type="submit" class="btn btn-primary primary-dark align-self-end"
                  [disabled]="fileUploadForm.invalid || uploadProgress || disabled">
                  {{ t(uploadButtonTranslationKey) }}
                </button>
              }
            </div>
          }
        </div>

        @if (uploadProgress && (source === 'remote' || source === 'local')) {
          <div class="uploading-progress">
            <div class="holder">
              <!-- <multisite-loader-globe-animation-detail *ngIf="uploadProgress" [width]="100" [height]="100">
            </multisite-loader-globe-animation-detail> -->
            <div class="progress">
              @if (uploadProgress) {
                <div class="progress-bar" role="progressbar" aria-label="Upload progress indicator"
                  [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100"
                [ngStyle]="{ width: uploadProgress + '%' }"></div>
              }
              @if (uploadProgress) {
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="doCancelUpload()"
                  >
                  <span aria-hidden="true">
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                </button>
              }
            </div>
          </div>
        </div>
      }


    </form>
  </tab>
  <tab heading="{{t('content_management.internet')}}" (selectTab)="changeSource('remote',$event)">
    <form class="position-relative" [formGroup]="fileUploadForm" (submit)="onUploadSubmit()" role="form">

      <div class="row mt-4">
        <div class="col-lg-6">
          <label for="remoteFile" class="form-label">{{ t(remoteFileDescriptionTranslationKey)
            }}<span class="required-sign">*</span>
          </label>
          <div class="input-group">
            <span class="input-group-text" id="fileAddressLabel">{{
              t('content_management.file_address')
            }}</span>
            <input type="text" class="form-control" id="remoteFile" formControlName="remoteFileUrl"
              aria-describedby="fileAddressLabel"
              placeholder="https://www.mycompanysite.com/images/banners/companybanner_wide.jpg"
              [attr.disabled]="disabled ? true : null" />
            @if (!askForLicenceAndCredit) {
              <button type="submit" class="btn btn-sm btn-primary primary-dark "
                [disabled]="fileUploadForm.invalid || uploadProgress || disabled">
                {{ t(uploadButtonTranslationKey) }}
              </button>
            }
            @if (
              fileUploadForm.get('remoteFileUrl').errors?.minlength &&
              fileUploadForm.get('remoteFileUrl').touched
              ) {
              <div class="invalid-feedback">
                {{ t('common.too_short') }}
              </div>
            }

          </div>
          <div class="form-text">{{ t(fileInstructionsTranslationKey) }}</div>
          @if (remoteImageUrlError && source === 'remote') {
            <alert [type]="'warning'"><span *transloco="let t">{{
              t('content_management.remote_image_url_error')
            }}</span>
          </alert>
        }
        <!-- Preview an image from the internet before the user confirms it (before upload) -->
        @if (source === 'remote' && this.fileUploadForm.get('remoteFileUrl').value && !remoteImageUrlError) {
          <div class="gallery w-sm-100 w-50 mt-3"
            >
            <p>{{t('content_management.happy_with_image')}} {{t('common.click_confirm')}}</p>
            <div class="gallery-item">
              <div class="card bg-dark text-white">
                <img class="card-img" [src]="this.fileUploadForm.get('remoteFileUrl').value" [alt]="''">
              </div>
            </div>
          </div>
        }
      </div>
      <div class="col-lg-6">
        @if (askForLicenceAndCredit) {
          <div class="input-self mb-3">
            <label for="licence" class="form-label">{{ t('common.licence')
              }}<span class="required-sign">*</span>
            </label>
              <div class="input-group" [ngClass]="{
              'ng-invalid':
                fileUploadForm.get('licence').invalid &&
                fileUploadForm.get('licence').touched,
              'ng-valid':
                fileUploadForm.get('licence').valid &&
                fileUploadForm.get('licence').touched &&
                fileUploadForm.get('licence').dirty
            }">
              <span class="input-group-text text-primary-light">
                <i class="fa fa-circle-check" aria-hidden="true"></i>
              </span>
              <input class="form-control" type="text" formControlName="licence" id="licence"
                [attr.disabled]="disabled ? true : null" placeholder="Creative Commons 2.0 Share Alike" />
              @if (
                fileUploadForm.get('licence').errors?.required &&
                fileUploadForm.get('licence').touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.required') }}
                </div>
              }
              @if (
                fileUploadForm.get('licence').errors?.licence &&
                fileUploadForm.get('licence').touched
                ) {
                <div class="invalid-feedback">
                  <!--  -->
                </div>
              }
            </div>
            <div class="form-text">
              {{ t('content_management.image_licence') }}
            </div>
          </div>
        }

        @if (askForLicenceAndCredit) {
          <div class="input-self mb-3">
            <label for="licence_url" class="form-label">{{ t('common.licence_url') }}
            </label>
              <div class="input-group" [ngClass]="{
              'ng-invalid':
                fileUploadForm.get('licence_url').invalid &&
                fileUploadForm.get('licence_url').touched,
              'ng-valid':
                fileUploadForm.get('licence_url').valid &&
                fileUploadForm.get('licence_url').touched &&
                fileUploadForm.get('licence_url').dirty
            }">
              <span class="input-group-text text-primary-light">
                <i class="fa fa-link" aria-hidden="true"></i>
              </span>
              <input class="form-control" type="text" formControlName="licence_url" id="licence_url"
                [attr.disabled]="disabled ? true : null"
                placeholder="https://creativecommons.org/licenses/by-sa/4.0/" />
              @if (
                fileUploadForm.get('licence_url').errors?.required &&
                fileUploadForm.get('licence_url').touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.required') }}
                </div>
              }
              @if (
                fileUploadForm.get('licence_url').errors?.minlength &&
                fileUploadForm.get('licence_url').touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.too_short') }}
                </div>
              }
            </div>
            <div class="form-text">
              {{ t('content_management.image_licence_address') }}
            </div>
          </div>
        }

        @if (askForLicenceAndCredit) {
          <div class="input-self mb-3">
            <label for="credit" class="form-label">{{ t('common.credit')
              }}<span class="required-sign">*</span>
            </label>
              <div class="input-group" [ngClass]="{
              'ng-invalid':
                fileUploadForm.get('credit').invalid &&
                fileUploadForm.get('credit').touched,
              'ng-valid':
                fileUploadForm.get('credit').valid &&
                fileUploadForm.get('credit').touched &&
                fileUploadForm.get('credit').dirty
            }">
              <span class="input-group-text text-primary-light">
                <i class="fa fa-id-card" aria-hidden="true"></i>
              </span>
              <input class="form-control" type="text" formControlName="credit" id="credit"
                placeholder="UNICEF/UN0792788/Tibaweswa" [attr.disabled]="disabled ? true : null" />
              @if (
                fileUploadForm.get('credit').errors?.required &&
                fileUploadForm.get('credit').touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.required') }}
                </div>
              }
              @if (
                fileUploadForm.get('credit').errors?.minlength &&
                fileUploadForm.get('credit').touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.too_short') }}
                </div>
              }
            </div>
            <div class="form-text">
              {{ t('content_management.credit') }}
            </div>
          </div>
        }
      </div>
      @if (!emitOnChange) {
        <div class="d-flex flex-column w-100 my-2 justify-content-end align-items-end my-3">
          @if (errorMessage) {
            <alert class="mt-1 w-100" [type]="'warning'">
              <strong class="mr-1">
                {{ t('common.problem') }}
              </strong>
              {{ t(errorMessage) }}
            </alert>
          }
          @if (successMessage) {
            <alert class="mt-1 w-100" [type]="'success'" [dismissOnTimeout]="5000">
              <strong class="mr-1">
                {{ t('common.success') }}
              </strong>
              {{ t(successMessage) }}
            </alert>
          }
          <!-- <p>Errors: {{fileUploadForm.get('remoteFileUrl').errors | json}}</p> -->
          @if (askForLicenceAndCredit) {
            <button type="submit" class="btn btn-primary primary-dark align-self-end"
              [disabled]="fileUploadForm.invalid || uploadProgress || disabled">
              {{ t(uploadButtonTranslationKey) }}
            </button>
          }
        </div>
      }

    </div>

    @if (uploadProgress && (source === 'remote' || source === 'local')) {
      <div class="uploading-progress">
        <div class="holder">
          <!-- <multisite-loader-globe-animation-detail *ngIf="uploadProgress" [width]="100" [height]="100">
        </multisite-loader-globe-animation-detail> -->
        <div class="progress">
          @if (uploadProgress) {
            <div class="progress-bar" role="progressbar" aria-label="Upload progress indicator"
              [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100"
            [ngStyle]="{ width: uploadProgress + '%' }"></div>
          }
          @if (uploadProgress) {
            <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="doCancelUpload()"
              >
              <span aria-hidden="true">
                <i class="fa-solid fa-xmark"></i>
              </span>
            </button>
          }
        </div>
      </div>
    </div>
  }
</form>
</tab>
</tabset>
</div>